/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CargoWeight
 */
export interface CargoWeight {
    /**
     * 
     * @type {Date}
     * @memberof CargoWeight
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof CargoWeight
     */
    weight: number;
}

export function CargoWeightFromJSON(json: any): CargoWeight {
    return CargoWeightFromJSONTyped(json, false);
}

export function CargoWeightFromJSONTyped(json: any, ignoreDiscriminator: boolean): CargoWeight {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'weight': json['weight'],
    };
}

export function CargoWeightToJSON(value?: CargoWeight | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'weight': value.weight,
    };
}


